<template>
  <v-row>
    <v-col
      cols="12"
    >
      <v-row v-if="isChip">
        <v-col cols="9">
          <input-radio
            v-model="payload.indRevisarValor"
            label="Revisar valor:"
            :options="reviewOptions"
            disabled
            row
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <input-select
            id="input:tipoValorProduto"
            v-model="payload.tipoValorProduto"
            :rules="[requiredRule]"
            :items="tipoValorProdutoOptions"
            label="Tipo do valor"
            disabled
            required
          />
        </v-col>
        <v-col
          v-if="isGiftCard"
          cols="6"
        >
          <input-text
            v-if="displayValueDesc"
            id="input:descricaoValor"
            v-model="payload.descricaoValor"
            label="Descrição valor"
            disabled
          />
          <slot />
        </v-col>
      </v-row>
      <v-row v-if="display && !displayRange">
        <v-col
          cols="6"
        >
          <input-money
            id="input:vlrProdutoServico"
            v-model="payload.vlrProdutoServico"
            label="Valor produto"
            disabled
          />
        </v-col>
      </v-row>
      <v-row v-if="display && displayRange">
        <v-col
          cols="6"
        >
          <input-money
            id="input:vlrVariavelMin"
            v-model="payload.vlrVariavelMin"
            label="Valor mínimo"
            disabled
          />
        </v-col>
        <v-col
          cols="6"
        >
          <input-money
            id="input:vlrVariavelMax"
            v-model="payload.vlrVariavelMax"
            label="Valor máximo"
            disabled
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import TypeProductValue from '@/app/arch/enums/TypeProductValue';
import RulesMixin from '@/app/arch/mixins/RulesMixin';

export default {
  name: 'RangeValoresProduto',
  mixins: [RulesMixin],
  props: {
    payload: {
      type: Object,
      default() {
        return {
          descricaoValor: '',
          tipoValorProduto: '',
          vlrProdutoServico: '',
          vlrVariavelMin: '',
          vlrVariavelMax: '',
          produtoServicoCategoria: '',
          indRevisarValor: '',
        };
      },
    },
    displayValueDesc: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    tipoValorProdutoOptions: TypeProductValue,
    reviewOptions: [
      {
        value: true,
        label: 'Sim',
      },
      {
        value: false,
        label: 'Não',
        color: 'primary',
      },
    ],
  }),
  computed: {
    display() {
      return this.payload.tipoValorProduto !== 'G';
    },
    displayRange() {
      return this.payload.tipoValorProduto === 'V';
    },
    isEdit() {
      return this.$route.params.id;
    },
    getOriginalValue() {
      return this.produto.originalTipoValor;
    },
    isGiftCard() {
      return this.payload.produtoServicoCategoria === 'GC';
    },
    isChip() {
      return this.payload.produtoServicoCategoria === 'CP';
    },
    isEditChip() {
      return this.isChip && this.isEdit;
    },
  },
  watch: {
    getOriginalValue: {
      immediate: true,
      handler(value) {
        if (value) {
          this.computedValueOptions();
        }
      },
    },
  },
  methods: {
    computedValueOptions() {
      if (this.isEdit) {
        if (this.getOriginalValue === 'G') {
          this.removeMoreOptions();
        } else {
          this.removeGradeOption();
        }
      }
    },
    removeMoreOptions() {
      const gradeOption = this.tipoValorProdutoOptions.find(
        (item) => item.value === 'G',
      );
      this.tipoValorProdutoOptions = [gradeOption];
    },
    removeGradeOption() {
      const gradeIndex = this.tipoValorProdutoOptions.findIndex(
        (item) => item.value === 'G',
      );
      if (gradeIndex > 0) {
        this.tipoValorProdutoOptions.splice(
          gradeIndex,
          1,
        );
      }
    },
  },
  inject: {
    produto: {
      default() {
        return {
          loading: '',
          originalTipoValor: '',
        };
      },
    },
  },
};
</script>
